// extracted by mini-css-extract-plugin
module.exports = {"slide-over":"SlideOver_slide-over__1GGmJ","active":"SlideOver_active__2xzbO"};